import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Despesas() {
  const [despesas, setDespesas] = useState([]);
  const [form, setForm] = useState({ data_despesa: '', local: '', servico: '', valor: '', observacao: '', pago_por: '', reembolsado: false });
  const [editando, setEditando] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const res = await api.get('/despesas/');
    setDespesas(res.data);
  }

  async function salvar() {
    if (editando) {
      await api.put(`/despesas/${editando}`, form);
    } else {
      await api.post('/despesas/', form);
    }
    setForm({ data_despesa: '', local: '', servico: '', valor: '', observacao: '', pago_por: '', reembolsado: false });
    setEditando(null);
    setMostrarForm(false);
    carregar();
  }

  function editar(d) {
    setForm({
      data_despesa: d.data_despesa?.substring(0, 10) || '',
      local: d.local || '',
      servico: d.servico || '',
      valor: d.valor || '',
      observacao: d.observacao || '',
      pago_por: d.pago_por || '',
      reembolsado: d.reembolsado || false,
    });
    setEditando(d.id);
    setMostrarForm(true);
  }

  async function deletar(id) {
    if (window.confirm('Remover esta despesa?')) {
      await api.delete(`/despesas/${id}`);
      carregar();
    }
  }

  const total = despesas.reduce((acc, d) => acc + Number(d.valor || 0), 0);
  const totalNaoReembolsado = despesas.filter(d => !d.reembolsado).reduce((acc, d) => acc + Number(d.valor || 0), 0);

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Despesas</h1>
          <button style={styles.botaoNovo} onClick={() => { setMostrarForm(true); setEditando(null); setForm({ data_despesa: '', local: '', servico: '', valor: '', observacao: '', pago_por: usuario.nome || '', reembolsado: false }); }}>
            + Nova Despesa
          </button>
        </div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <p style={styles.cardLabel}>Total geral</p>
            <p style={styles.cardValor}>R$ {total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
          </div>
          <div style={styles.card}>
            <p style={styles.cardLabel}>Pendente reembolso</p>
            <p style={{ ...styles.cardValor, color: '#e53935' }}>R$ {totalNaoReembolsado.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
          </div>
        </div>

        {mostrarForm && (
          <div style={styles.form}>
            <h3 style={styles.formTitulo}>{editando ? 'Editar Despesa' : 'Nova Despesa'}</h3>
            <div style={styles.grid}>
              <div style={styles.campo}>
                <label style={styles.label}>Data *</label>
                <input style={styles.input} type="date" value={form.data_despesa} onChange={e => setForm({ ...form, data_despesa: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Valor (R$) *</label>
                <input style={styles.input} type="number" min="0" step="0.01" value={form.valor} onChange={e => setForm({ ...form, valor: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Serviço *</label>
                <input style={styles.input} value={form.servico} onChange={e => setForm({ ...form, servico: e.target.value })} placeholder="Ex: Transporte, Cartório..." />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Local</label>
                <input style={styles.input} value={form.local} onChange={e => setForm({ ...form, local: e.target.value })} placeholder="Ex: JUCESP, Cartório Centro..." />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Pago por *</label>
                <input style={styles.input} value={form.pago_por} onChange={e => setForm({ ...form, pago_por: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Reembolsado</label>
                <select style={styles.input} value={form.reembolsado} onChange={e => setForm({ ...form, reembolsado: e.target.value === 'true' })}>
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </select>
              </div>
              <div style={{ ...styles.campo, gridColumn: 'span 2' }}>
                <label style={styles.label}>Observação</label>
                <textarea style={{ ...styles.input, height: '60px' }} value={form.observacao} onChange={e => setForm({ ...form, observacao: e.target.value })} />
              </div>
            </div>
            <div style={styles.formBotoes}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={() => { setMostrarForm(false); setEditando(null); }}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Data', 'Serviço', 'Local', 'Valor', 'Pago por', 'Reembolsado', 'Observação', 'Ações'].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {despesas.map(d => (
              <tr key={d.id} style={styles.tr}>
                <td style={styles.td}>{d.data_despesa?.substring(0, 10)}</td>
                <td style={styles.td}>{d.servico}</td>
                <td style={styles.td}>{d.local || '-'}</td>
                <td style={{ ...styles.td, fontWeight: '500' }}>R$ {Number(d.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                <td style={styles.td}>{d.pago_por}</td>
                <td style={styles.td}>
                  <span style={{ ...styles.badge, backgroundColor: d.reembolsado ? '#e8f5e9' : '#fff3e0', color: d.reembolsado ? '#388e3c' : '#f57c00' }}>
                    {d.reembolsado ? 'Sim' : 'Não'}
                  </span>
                </td>
                <td style={{ ...styles.td, fontSize: '12px', color: '#888' }}>{d.observacao || '-'}</td>
                <td style={styles.td}>
                  <button style={styles.botaoEditar} onClick={() => editar(d)}>Editar</button>
                  <button style={styles.botaoDesativar} onClick={() => deletar(d.id)}>Remover</button>
                </td>
              </tr>
            ))}
            {despesas.length === 0 && (
              <tr>
                <td colSpan={8} style={{ ...styles.td, textAlign: 'center', color: '#aaa', padding: '2rem' }}>
                  Nenhuma despesa cadastrada
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  cards: { display: 'flex', gap: '16px', marginBottom: '1.5rem' },
  card: { backgroundColor: '#fff', padding: '1.25rem 1.5rem', borderRadius: '8px', border: '1px solid #e0e0e0', minWidth: '200px' },
  cardLabel: { fontSize: '12px', color: '#888', marginBottom: '4px' },
  cardValor: { fontSize: '22px', fontWeight: '600', color: '#1a1a2e' },
  form: { backgroundColor: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formTitulo: { margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px' },
  input: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  formBotoes: { display: 'flex', gap: '10px', marginTop: '1rem' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  badge: { padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', marginRight: '6px' },
  botaoDesativar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
};